import React from 'react';
import PropTypes from 'prop-types';
import { BasicTooltip } from '../../components';

const ShiftAssignmentStatus = ({ item, type }) => {
  const text = item?.status;
  const currentType = type ? 'text' : 'dot dot';

  let currentClass = '';
  let translatedText = '';

  switch (text) {
    case 'pending':
      currentClass = `${currentType}-warning`;
      translatedText = 'Pendiente';
      break;
    case 'executed':
      currentClass = `${currentType}-success`;
      translatedText = 'Ejecutado';
      break;
    case 'rejected':
      currentClass = `${currentType}-danger`;
      translatedText = 'Rechazado';
      break;
    default:
      currentClass = `${currentType}-secondary`;
      translatedText = text || '';
  }

  return (
    <BasicTooltip text={translatedText}>
      <span className={currentClass} data-tag="allowRowEvents">
        <b>{translatedText}</b>
      </span>
    </BasicTooltip>
  );
};

ShiftAssignmentStatus.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired
  }).isRequired,
  type: PropTypes.bool
};

ShiftAssignmentStatus.defaultProps = {
  type: false
};

export default ShiftAssignmentStatus;
